import { ACCESS_TOKEN_KEY, ACCESS_USERID_KEY } from '@/constant/config';
import { request } from '@/utils/request';
import Storage from '@/utils/Storage';

/**
 * 领取兑换码奖励
 * @returns
 */
export const getBonusCDK = (code: any) => {
  const userid = Storage.getAccess(ACCESS_USERID_KEY);
  return request({
    url: '/hall/get_cdk',
    method: 'post',
    data: { userid, code }
  });
};

/**
 * vip 奖励配置查询
 * @returns
 */
export const qryVipAwardConfig = () => {
  const userid = Storage.getAccess(ACCESS_USERID_KEY);
  return request({
    url: '/yfapi/DBMonitor.gsp_gr_qryvipawardconfig',
    method: 'post',
    data: { userid }
  });
};

/**
 * 每日充值用户信息查询
 * @returns
 */
export const qryTaskInfoPay = () => {
  const userid = Storage.getAccess(ACCESS_USERID_KEY);
  return request({
    url: '/yfapi/DBMonitor.gsp_gr_qrytaskinfo_pay',
    method: 'post',
    data: { userid }
  });
};

/**
 * 每日充值奖励
 * @returns
 */
export const fetchTaskPayAward = (data: any) => {
  const userid = Storage.getAccess(ACCESS_USERID_KEY);
  const token = Storage.getAccess(ACCESS_TOKEN_KEY);
  return request({
    url: '/gamer/fetchtaskaward_pay',
    method: 'post',
    data: { ...data, userid, token }
  });
};

/**
 * 每日局数用户信息查询
 * @returns
 */
export const qryTaskInfoRounds = () => {
  const userid = Storage.getAccess(ACCESS_USERID_KEY);
  return request({
    url: '/yfapi/DBMonitor.gsp_gr_qrytaskinfo_rounds',
    method: 'post',
    data: { userid }
  });
};

/**
 * 每日局数奖励
 * @returns
 */
export const fetchTaskRoundsAward = (data: any) => {
  const userid = Storage.getAccess(ACCESS_USERID_KEY);
  const token = Storage.getAccess(ACCESS_TOKEN_KEY);
  return request({
    url: '/gamer/fetchtaskaward_rounds',
    method: 'post',
    data: { ...data, userid, token }
  });
};

/**
 * 每日流水用户信息查询
 * @returns
 */
export const qryTaskInfoBet = () => {
  const userid = Storage.getAccess(ACCESS_USERID_KEY);
  return request({
    url: '/yfapi/DBMonitor.gsp_gr_qrytaskinfo_bet',
    method: 'post',
    data: { userid }
  });
};

/**
 * 每日流水奖励
 * @returns
 */
export const fetchTaskBetAward = (data: any) => {
  const userid = Storage.getAccess(ACCESS_USERID_KEY);
  const token = Storage.getAccess(ACCESS_TOKEN_KEY);
  return request({
    url: '/gamer/fetchtaskaward_bet',
    method: 'post',
    data: { ...data, userid, token }
  });
};

/**
 * 生涯用户信息查询
 * @returns
 */
export const qryTaskInfoScore = () => {
  const userid = Storage.getAccess(ACCESS_USERID_KEY);
  return request({
    url: '/yfapi/DBMonitor.gsp_gr_qrytaskinfo_score',
    method: 'post',
    data: { userid }
  });
};

/**
 * 生涯奖励
 * @returns
 */
export const fetchTaskScoreAward = (data: any) => {
  const userid = Storage.getAccess(ACCESS_USERID_KEY);
  const token = Storage.getAccess(ACCESS_TOKEN_KEY);
  return request({
    url: '/gamer/fetchtaskaward_score',
    method: 'post',
    data: { ...data, userid, token }
  });
};

/**
 * 红点标记查询
 * @returns
 */
export const getTaskFlag = () => {
  const userid = Storage.getAccess(ACCESS_USERID_KEY);
  const token = Storage.getAccess(ACCESS_TOKEN_KEY);
  return request({
    url: '/gamer/get_task_red_flag',
    method: 'post',
    data: { userid, token }
  });
};
